<template>
  <div>
    <v-card color="ma-0 pa-0" :loading="loading">
      <document-action-header :title="$t('Alerts')" @on-close-click="onCloseClick">
        <template slot="actionTemplate">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="add">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Add') }}</span>
          </v-tooltip>
        </template>
      </document-action-header>

      <v-card-text class="overflow-y-auto pa-2 overflow-x-hidden" style="max-height: 250px;">
        <v-row justify="center" align="center" v-if="alertList.length == 0 && !loading">
          <div class="text-center">
            <a link @click="add">
              {{ $t('Add') }}
              <v-icon>mdi-plus</v-icon>
            </a>
          </div>
        </v-row>

        <template v-for="alert in alertList">
          <AlertItem
            :alert="alert"
            v-bind:key="alert.id"
            @on-edit-alert="onEdit"
            @on-remove-alert="onRemove"
          />
        </template>
      </v-card-text>
    </v-card>
    <alert-modal :ref="modalKey" @on-alert-saved="onSaved" />
  </div>
</template>

<script>
import DocumentActionHeader from '@/components/search/results/list/item/actions/DocumentActionHeader';
import AlertItem from '@/components/search/results/list/item/actions/alert/AlertItem';
import AlertModal from '@/components/search/results/list/item/actions/alert/AlertModal';
import AlertService from '@/services/AlertService';
import Alert from '@/ecm/models/search/results/list/Alert';

export default {
    name: 'alertList',
    components: {
        DocumentActionHeader,
        AlertItem,
        AlertModal
    },
    props: {
        documentId: {
            type: Number,
            required: true
        }
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            alertList: [],
            loading: false,
            modalKey: 'modalAlert'
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        }
    },
    methods: {
        onCloseClick() {
            this.$emit('on-close-click');
        },
        onSaved() {
            this.loadData();
        },
        onRemove(alertId) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-warning',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel')
            }).then(res => {
                if (res == 1) {
                    AlertService.remove(alertId).then(result => {
                        if (result) {
                            this.loadData();
                        }
                    });
                }
            });
        },
        onEdit(alert) {
            this.modalInstance.edit(alert);
        },
        add() {
            this.modalInstance.new(this.documentId);
        },
        loadData() {
            this.loading = true;
            AlertService.getDocumentList(this.documentId).then(data => {
                this.alertList = data.map(function(dto) {
                    return new Alert(dto);
                });
                this.loading = false;
                this.$emit('on-alert-updated', data.length);
            });
        }
    }
};
</script>